import ErrorStackParser from 'error-stack-parser';

class ErrorTracker {
    constructor() {
        this.endpoint = '/api/logs/client-error';
        this.initialized = false;
    }

    init() {
        if (this.initialized) return;

        // Global error handler
        window.onerror = (message, source, lineno, colno, error) => {
            this.logError({
                message,
                source,
                lineno,
                colno,
                error,
                type: 'uncaught_exception'
            });
        };

        // Unhandled promise rejections
        window.onunhandledrejection = (event) => {
            this.logError({
                message: event.reason ? (event.reason.message || event.reason) : 'Unhandled Rejection',
                error: event.reason,
                type: 'unhandled_rejection'
            });
        };

        this.initialized = true;
        console.log('Error Tracker initialized');
    }

    async logError(errorData) {
        // Prevent infinite loops if error logging itself fails
        if (errorData?.message?.includes(this.endpoint)) return;

        try {
            const error = errorData.error instanceof Error ? errorData.error : new Error(errorData.message);

            let stack = [];
            try {
                stack = ErrorStackParser.parse(error);
            } catch (e) {
                // Fallback if parsing fails
                stack = error.stack || [];
            }

            const payload = {
                message: error.message || errorData.message,
                stack: error.stack,
                parsedStack: stack,
                url: window.location.href,
                userAgent: navigator.userAgent,
                timestamp: new Date().toISOString(),
                type: errorData.type || 'error',
                user: this.getUserInfo() // Implement this to get current user info if available
            };

            // Send to backend
            // Use fetch to avoid dependency on axios being configured specifically
            await fetch(this.endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

        } catch (loggingError) {
            console.error('Failed to send error log to server:', loggingError);
        }
    }

    getUserInfo() {
        // Try to get user info from localStorage or session
        try {
            const userStr = localStorage.getItem('user');
            if (userStr) {
                const user = JSON.parse(userStr);
                return { id: user.id || user._id, email: user.email };
            }
        } catch (e) {
            // Ignore
        }
        return null;
    }
}

export const errorTracker = new ErrorTracker();
